import React from 'react';
import { useTranslation } from 'react-i18next';

import { FileTypeTranslate } from '../../../constants/FileType';
import { Button, Popconfirm } from 'antd';
import {
  DeleteOutlined,
  UploadOutlined,
  CloseOutlined,
} from '@ant-design/icons';

function Header({ currentView, carouselProps }) {
  const { t } = useTranslation();
  const { name, type, resolution, url } = currentView;
  const { modalProps, onDelete } = carouselProps;
  const { onClose } = modalProps;

  return (
    <div className="react-images__header react-images__header--isModal css-1rkjyjh css-1ycyyax file-viewer__header">
      <div className="file-viewer__header-info">
        <div className="file-viewer__header-title">{name}</div>
        <div className="file-viewer__header-description">
          {FileTypeTranslate[type](t)} {resolution ? `, ${resolution}` : ''}
        </div>
      </div>
      <div className="file-viewer__header-actions">
        <Button
          type="link"
          ghost
          href={url}
          target="_blank"
          icon={<UploadOutlined width={21} height={21} rotate={180} />}
        />
        <Popconfirm
          overlayClassName="file-viewer__pop-overlay"
          title={t('delete-content-warning')}
          cancelText={t('to-leave')}
          okText={t('delete')}
          onConfirm={onDelete}
        >
          <Button
            type="link"
            ghost
            icon={<DeleteOutlined width={21} height={21} />}
          />
        </Popconfirm>
        <Button
          onClick={onClose}
          type="link"
          ghost
          icon={<CloseOutlined width={21} height={21} />}
        />
      </div>
    </div>
  );
}

export default Header;
